import React, { useState } from 'react';
import BeatLoader from 'react-spinners/BeatLoader';
import reportService from '../../../services/reportService';
import { FaAngleDoubleDown,FaCheckDouble,FaHourglassEnd   } from "react-icons/fa";
import ButtonGroup from '../components/ButtonGroup';
import { useEffect } from 'react';

const override = {
  display: "block",
  margin: "15px auto",
  borderColor: "red",
};

const ReportByMixMobile = (props) => {
  const { showEvents, fetchData } = props;

  return (
    <div className='flex flex-col justify-center mx-2'>
      {
        showEvents.map((v, i) => {
          return (
            // <div key={i}
            //  className='mt-2 p-2 shadow-lg border border-b-2 border-b-background'>
            //   <div className='flex flex-col justify-center mt-1'>
            //     <div className='flex justify-between items-center'>
            //       <span className='text-sm font-bold'>
            //         Mix: {v.teamCount}
            //       </span>
            //       <div className='flex gap-3'>
            //         <span className='text-xs font-bold'>
            //           Active: {v.activeCount}
            //         </span>
            //         <span className='text-xs font-bold'>
            //           Purchase: {v.purchasedCount}
            //         </span>
            //       </div>
            //     </div>
            //     <div className='flex justify-between items-center'>
            //       <div className='text-xs font-semibold'>
            //         <span className='text-gray-500'>Total Bet Amount: </span><span className=''>{v.totalBetAmount}</span>
            //       </div>
            //       <div className='text-xs ml-2 font-semibold'>
            //         <span className='text-gray-500'>Total Risk : </span><span className=''>{v.totalWinAmount}</span>
            //       </div>
            //     </div>
            //     <div className='flex justify-between items-center'>
            //       <div className='text-xs font-semibold'>
            //         <span className='text-gray-500'>Total Over Amount: </span><span className=''>{v.overAmount}</span>
            //       </div>
            //       <div className='text-xs ml-2 font-semibold'>
            //         <span className='text-gray-500'>Total Win Amount: </span><span className=''>{v.totalWinAmount}</span>
            //       </div>
            //     </div>
            //   </div>
            //     <Row
            //       teamCount={v.teamCount}
            //       fetchData={fetchData}
            //       selectedDate={v.selectedDate}
            //     />
            // </div>
            <div
              key={i}
              className="mt-2 p-4 rounded-lg bg-white text-customInk dark:bg-customSurface dark:border-customBorder dark:text-customWhite shadow-accountPanel border border-customTitleColor transition-all"
            >
              <div className="flex flex-col gap-3">
                <div className="flex justify-between items-center">
                  <h3 className="text-base font-bold text-customInk dark:text-customHeading">Mix: {v.teamCount}</h3>
                  <div className="flex gap-4 text-xs font-semibold text-customSecondaryText dark:text-customMuted">
                    <span className="bg-customGray dark:bg-customSurfaceMuted px-2 py-1 rounded">
                      Active: <span className="text-customInk dark:text-customWhite">{v.activeCount}</span>
                    </span>
                    <span className="bg-customGray dark:bg-customSurfaceMuted px-2 py-1 rounded">
                      Purchase: <span className="text-customInk dark:text-customWhite">{v.purchasedCount}</span>
                    </span>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2 text-xs font-medium text-customSecondaryText dark:text-customMuted">
                  <div className="flex justify-between">
                    <span className="text-customFontGreen">Total Bet Amount</span>
                    <span className="text-customInk dark:text-customWhite">{v.totalBetAmount}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-customFontGreen">Total Risk</span>
                    <span className="text-customInk dark:text-customWhite">{v.totalRiskAmount}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-customFontGreen">Total Over Amount</span>
                    <span className="text-customInk dark:text-customWhite">{v.overAmount}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-customFontGreen">Total Win Amount</span>
                    <span className="text-customInk dark:text-customWhite">{v.totalWinAmount}</span>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <Row
                  teamCount={v.teamCount}
                  fetchData={fetchData}
                  selectedDate={v.selectedDate}
                />
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

export default ReportByMixMobile;

const Row = ({ teamCount, fetchData, selectedDate }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [voucherList, setVoucherList] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (isExpanded) {
      if (voucherList.length === 0) fetchDataDetails();
    }
  }, [isExpanded])

  const fetchDataDetails = async (v) => {
    try {
      setIsLoading(true);
      const payload = {
        teamCount: teamCount,
        selectedDate: selectedDate
      }

      const response = await reportService.reportByMixDetails(payload);

      if (response.status === 200) {
        const filteredList = response.data.data.filter(item => item.mixDetailLists.length > 0);
        setVoucherList(filteredList);
      }
    }
    catch (error) {
      console.log(error)
    }
    finally {
      setIsLoading(false);
    }
  }

  return (
    <div className='flex flex-col border border-customTitleColor p-1 bg-white text-customInk dark:border-customBorder dark:bg-customSurface mt-2 rounded-md shadow-md'>
      <div className='flex justify-center items-center'>
        <button
          className='text-customAccentBlue text-xs mt-1 flex items-center gap-1'
          onClick={() => {
            setIsExpanded(prev => !prev);
          }}
        >
          {isExpanded ? 'Hide Details' : 'Show Details'}
          <FaAngleDoubleDown className='text-xs' />
        </button>
      </div>
      {
        isExpanded ?
          isLoading ?
            <BeatLoader
              color={'#292E4C'}
              loading={true}
              cssOverride={override}
              size={15}
              aria-label="Loading Spinner"
              data-testid="loader"
            /> :
            voucherList.length > 0 ?
              voucherList.map((outer) =>
                outer.mixDetailLists.map((el, i) => (
                  <div className='flex flex-col bg-customGray dark:bg-customSurfaceMuted p-2 rounded-sm font-semibold' key={i}>
                    <div className='flex justify-between'>
                      <span className=''>{el.postingNo}</span>
                      <span className='text-customFontLightGreen text-sm flex items-center gap-1'>{el.status} {el.status === "Finished" ? <FaCheckDouble className='text-customFontLightGreen text-xs' /> : el.status === "Pending" ? <FaHourglassEnd className='text-customFontLightGreen text-xs' /> : null}</span>
                    </div>
                    <span className='text-xs text-customFontVoilet'>{el.userName}</span>
                    <div className='flex justify-between text-xs mt-2 text-customFontGreen'>
                      <div className='flex flex-col'>
                        <span>Bet Amount</span>
                        <span className='text-customInk dark:text-customWhite'>{el.amount}</span>
                      </div>
                      <div className='flex flex-col'>
                        <span>Risk</span>
                        <span className='text-customInk dark:text-customWhite'>{el.riskAmount}</span>
                      </div>
                      <div className='flex flex-col'>
                        <span>Overed Amount</span>
                        <span className='text-customInk dark:text-customWhite'>{el.overedAmount}</span>
                      </div>
                    </div>
                    <ButtonGroup
                      data={el}
                      isMobile={true}
                      teamCount={teamCount}
                      fetchData={fetchData}
                    />
                  </div>
                ))
              )
              : null
          : null
      }
    </div>
  );
}
